export const mockCurrentUser = {
        uid: 'test-uid',
        email: 'honey.singhroigmail.com',
        displayName: 'Test User',
        photoURL: 'https://example.com/test-avatar.jpg',
        emailVerified: true,
        phoneNumber: null,
        isAnonymous: false,
        metadata: {},
        providerData: [],
        getIdToken: () => Promise.resolve('test-token'),
        getIdTokenResult: () => Promise.resolve({ token: 'test-token', claims: {} }),
        reload: () => Promise.resolve(),
        toJSON: () => ({})
}

export const mockInitialDbUser = {
        _id: 'test-db-id',
        authId: 'test-uid',
        email: 'honey.singhroigmail.com',
        name: 'Test User',
        organizationName: 'Test Organization',
        organizationWebsite: 'https://example.com',
        avatar: 'https://example.com/test-avatar.jpg',
        role: 'user',
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
        __v: 0
}